var domain = {
    appname: "福7",
    version: 139,
    aliyun: "https://f7tv.oss-accelerate.aliyuncs.com/domain.config",
    tencent: "https://livejk-1309827338.cos.accelerate.myqcloud.com/domain.config",
    domains: [
        "https://jk.qawsrt.cn/",
        "https://jk.vxcus.cn/",
        "https://jk.vxcvasdf.cn/",
        "https://jk.ssadf.cn/"
    ],
    tabLineColoor: '#007AFF',
    tabColor: '#A4B8CB',
    tabSelColor: '#007AFF',
    channelid: 4,
    freeLanchannelid: 4,
    appID: 'com.f7.livetv',
    serviceAgreement: "download/serviceAgreement.html",
    imApi: [
        "https://frljk.im1q.cn",
        "https://frljk.bgmim.cn",
        "https://frljk.imtgb.cn",
        "https://frljk.im2w.cn",
        "https://frljk.56im.cn"
    ],
    imAliyun: "https://freelantv.oss-accelerate.aliyuncs.com/domain.config",
    imTencent: "https://freelanjk-1309827338.cos.accelerate.myqcloud.com/domain.config",
    showDownload: true,
}

export default domain;